import { render, staticRenderFns } from "./PerseoLayout.vue?vue&type=template&id=e2c6e130&scoped=true"
import script from "./PerseoLayout.vue?vue&type=script&lang=js"
export * from "./PerseoLayout.vue?vue&type=script&lang=js"
import style0 from "./PerseoLayout.vue?vue&type=style&index=0&id=e2c6e130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c6e130",
  null
  
)

export default component.exports